Whether the job ad was initially posted by the requesting partner.

If your software cannot ingest objects that are created by another source,
this can be used to filter out such job ads and their associated applications.

`seekPostingSourceCode` can be used to determine more details about the source that initially posted the job ad.
